import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";

import { showApiErrorToast } from "@/lib/apiErrorHandling";

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      showApiErrorToast(error, query.meta);
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      showApiErrorToast(error, mutation.meta);
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      retry: false,
    },
  },
});
